import { PRODUCT_EXPORT_PRICE_CHANGES } from "../constants";
import { makePrivateApiCall } from "utilities/dist/api";
import { authExpire } from "../../auth/actions";
import { format, parseISO } from "date-fns";

export const exportProductPriceChanges = () => dispatch => {
    const params = {
        excludeNullCustomer: "",
        withCustomer: true,
        withProduct: true,
    };

    const csvColumns = [
        "Product Name",
        "UPC",
        "Customer Name",
        "Customer ID",
        "Previous Price",
        "New Price",
        "Effective Date",
    ];

    const prepareCsvData = price_changes => {
        if (!price_changes) return [];

        const csvData = price_changes.map(item => [
            item.product?.product,
            item.product?.upc,
            item.customer?.name,
            item.customer_id,
            item.old_price,
            item.new_price,
            format(parseISO(item.effective_date), "MM/dd/yyyy"),
        ]);
        return csvData;
    };

    const csvEscape = field => {
        const stringified = String(field ?? "");
        if (/[",\n\r]/.test(stringified)) {
            return `"${stringified.replace(/"/g, '""')}"`;
        }
        return stringified;
    };

    return makePrivateApiCall({
        url: "/product/price-change",
        method: "get",
        params,
    })
        .then(res => {
            if (res.data) {
                const product_price_changes = res.data.rows;
                dispatch({
                    type: PRODUCT_EXPORT_PRICE_CHANGES,
                    payload: product_price_changes,
                });
                const csvData = [csvColumns, ...prepareCsvData(product_price_changes)];
                if (csvData.length > 1) {
                    const csvFileData = csvData
                        .map(row => row.map(csvEscape).join(","))
                        .join("\r\n");

                    const aTag = document.createElement("a");
                    const csvFile = new Blob([csvFileData], {
                        type: "text/csv;charset=utf-8;",
                    });
                    const url = URL.createObjectURL(csvFile);
                    aTag.href = url;
                    aTag.download = `product_price_changes${".csv"}`;
                    aTag.click();
                    URL.revokeObjectURL(url);

                    return true;
                }
                return false;
            }
        })
        .catch(err => {
            if (err.response && err.response.status === 401) {
                return dispatch(authExpire());
            }
            throw err;
        });
};
